import { ApplicationConfig, LOCALE_ID } from '@angular/core';
import { provideRouter } from '@angular/router';
import { environment } from '../environments/environment';
import { platform } from '../platforms/platform';
import { provideHagebauPartnerSoftlineModules } from '@configs/hagebau-partner';
import { provideStorageLocation } from '@softapps/mde/storage-location';
import {
  provideSoftApps,
  SOFTLINE_ROUTES_APPS,
  SOFTLINE_ROUTES_PUBLIC,
} from '@softapps/core';
import { withLogin } from '@softapps/allgemein/login';
import { moduleRoutes, provideModuleOverview } from '@softapps/allgemein/modules';
import {
  connectionSettingsRoutes,
  contextStorageProviders,
  settingsProviders,
  settingsRoutes,
  userContextProviders,
  utilitiesProviders,
  vkforgContextProviders,
} from '@softapps/allgemein/utils';
import { passwordProviders, passwordRoutes } from '@softapps/allgemein/password';
import { pdfViewerProviders } from '@softapps/allgemein/pdf-viewer';
import { provideDarkTheme, remoteConfigProviders } from '@softline/application';
import {
  provideEslLinkStorageProviders,
  provideEslSearchProviders,
} from '@softapps/handel/esl-link-storage';
import { provideEslConfigModule } from '@softapps/handel/esl-config';
import { lagerCoreProviders } from '@softapps/lager/core';
import { provideABCAnalysisProviders } from '@softapps/lager/abc-analysis';

const [hagebauProviders, hagebauRoutes] = provideHagebauPartnerSoftlineModules();

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter([]),
    provideSoftApps({ connection: environment.connection }, withLogin()),

    {
      provide: SOFTLINE_ROUTES_APPS,
      useValue: [...hagebauRoutes.internal, ...moduleRoutes, ...settingsRoutes],
      multi: true,
    },
    {
      provide: SOFTLINE_ROUTES_PUBLIC,
      useValue: [...passwordRoutes, ...connectionSettingsRoutes, ...settingsRoutes],
      multi: true,
    },

    provideDarkTheme(false),

    ...utilitiesProviders,
    ...settingsProviders,
    ...passwordProviders,
    provideModuleOverview(),
    ...userContextProviders,
    ...remoteConfigProviders,
    ...contextStorageProviders,
    ...vkforgContextProviders,
    ...pdfViewerProviders,

    ...hagebauProviders,
    ...lagerCoreProviders,

    ...provideEslLinkStorageProviders({ storageSelection: true }),
    ...provideEslConfigModule(),
    ...provideEslSearchProviders(),
    ...provideStorageLocation(),
    ...provideABCAnalysisProviders(),

    ...platform.providers,
    { provide: LOCALE_ID, useValue: 'de' },
  ],
};
